"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS = exports.ROLE = exports.GROUPS = void 0;
exports.GROUPS = {
    ADMIN: 1,
    MANAGER: 2,
    USER: 3,
    DEV: 4,
    SITE_ADMIN: 5,
    SITE_MANAGER: 6,
    SITE_USER: 7,
    SITE_PROVIDER: 9,
    DIST_ADMIN: 10,
    DIST_MANAGER: 11,
    DIST_USER: 12 // D-011
};
exports.ROLE = {
    isDev: (groupId) => [4].includes(groupId),
    isIMBAdmin: (groupId) => [1].includes(groupId),
    isIMBUser: (groupId) => [1, 2, 3].includes(groupId),
    isPharmacyUser: (groupId) => [5, 6, 7, 9].includes(groupId)
};
// export class Role {
//   constructor(public groupId: number) {
//   }
//   public isDev = () => [4].includes(this.groupId);
//   public isIMBUser = () => [1, 2, 3].includes(this.groupId);
//   public isPharmacyUser = () => [5, 6, 7].includes(this.groupId);
// }
exports.PERMISSIONS = {
    // None
    NONE: "",
    // All
    DISPENSIFY: "dispensify",
    // NDC
    DISPENSIFY_NDC: "dispensify.ndc",
    DISPENSIFY_NDC_READ: "dispensify.ndc.read",
    DISPENSIFY_NDC_UPDATE: "dispensify.ndc.update",
    // ICD10
    DISPENSIFY_ICD10: "dispensify.icd10",
    DISPENSIFY_ICD10_READ: "dispensify.icd10.read",
    // User
    DISPENSIFY_USER: "dispensify.user",
    DISPENSIFY_USER_CREATE: "dispensify.user.create",
    DISPENSIFY_USER_READ: "dispensify.user.read",
    DISPENSIFY_USER_UPDATE: "dispensify.user.update",
    DISPENSIFY_USER_DELETE: "dispensify.user.delete",
    // User Group
    DISPENSIFY_USERGROUP: "dispensify.usergroup",
    DISPENSIFY_USERGROUP_CREATE: "dispensify.usergroup.create",
    DISPENSIFY_USERGROUP_READ: "dispensify.usergroup.read",
    DISPENSIFY_USERGROUP_UPDATE: "dispensify.usergroup.update",
    DISPENSIFY_USERGROUP_DELETE: "dispensify.usergroup.delete",
    // Site
    DISPENSIFY_SITE: "dispensify.site",
    DISPENSIFY_SITE_CREATE: "dispensify.site.create",
    DISPENSIFY_SITE_READ: "dispensify.site.read",
    DISPENSIFY_SITE_UPDATE: "dispensify.site.update",
    DISPENSIFY_SITE_DELETE: "dispensify.site.delete",
    // Inventory
    DISPENSIFY_INVENTORY: "dispensify.inventory",
    DISPENSIFY_INVENTORY_CREATE: "dispensify.inventory.create",
    DISPENSIFY_INVENTORY_READ: "dispensify.inventory.read",
    DISPENSIFY_INVENTORY_UPDATE: "dispensify.inventory.update",
    DISPENSIFY_INVENTORY_DELETE: "dispensify.inventory.delete",
    // Inventory Site
    DISPENSIFY_INVENTORYSITE: "dispensify.inventorysite",
    DISPENSIFY_INVENTORYSITE_CREATE: "dispensify.inventorysite.create",
    DISPENSIFY_INVENTORYSITE_READ: "dispensify.inventorysite.read",
    DISPENSIFY_INVENTORYSITE_UPDATE: "dispensify.inventorysite.update",
    DISPENSIFY_INVENTORYSITE_DELETE: "dispensify.inventorysite.delete",
    // Ledger
    DISPENSIFY_LEDGER: "dispensify.ledger",
    DISPENSIFY_LEDGER_CREATE: "dispensify.ledger.create",
    DISPENSIFY_LEDGER_READ: "dispensify.ledger.read",
    DISPENSIFY_LEDGER_UPDATE: "dispensify.ledger.update",
    DISPENSIFY_LEDGER_DELETE: "dispensify.ledger.delete",
    // EOB
    DISPENSIFY_EOB: "dispensify.eob",
    DISPENSIFY_EOB_CREATE: "dispensify.eob.create",
    DISPENSIFY_EOB_READ: "dispensify.eob.read",
    DISPENSIFY_EOB_UPDATE: "dispensify.eob.update",
    DISPENSIFY_EOB_DELETE: "dispensify.eob.delete",
    // Pad
    DISPENSIFY_PAD: "dispensify.pad",
    DISPENSIFY_PAD_READ: "dispensify.pad.read",
    DISPENSIFY_PAD_UPDATE: "dispensify.pad.update",
    DISPENSIFY_PAD_PROMPT: "dispensify.pad.prompt",
    // Patient
    DISPENSIFY_PATIENT: "dispensify.patient",
    DISPENSIFY_PATIENT_CREATE: "dispensify.patient.create",
    DISPENSIFY_PATIENT_READ: "dispensify.patient.read",
    DISPENSIFY_PATIENT_UPDATE: "dispensify.patient.update",
    DISPENSIFY_PATIENT_DELETE: "dispensify.patient.delete",
    // Provider
    DISPENSIFY_PROVIDER: "dispensify.provider",
    DISPENSIFY_PROVIDER_CREATE: "dispensify.provider.create",
    DISPENSIFY_PROVIDER_READ: "dispensify.provider.read",
    DISPENSIFY_PROVIDER_UPDATE: "dispensify.provider.update",
    DISPENSIFY_PROVIDER_DELETE: "dispensify.provider.delete",
    // Order
    DISPENSIFY_ORDER: "dispensify.order",
    DISPENSIFY_ORDER_CREATE: "dispensify.order.create",
    DISPENSIFY_ORDER_READ: "dispensify.order.read",
    DISPENSIFY_ORDER_DISPENSE: "dispensify.order.dispense",
    DISPENSIFY_ORDER_REVERSE: "dispensify.order.reverse",
    // Claim
    DISPENSIFY_CLAIM: "dispensify.claim",
    DISPENSIFY_CLAIM_CREATE: "dispensify.claim.read",
    DISPENSIFY_CLAIM_READ: "dispensify.claim.read",
    DISPENSIFY_CLAIM_RETRY: "dispensify.claim.retry",
    DISPENSIFY_CLAIM_REFILL: "dispensify.claim.refill",
    DISPENSIFY_CLAIM_ANALYTICS: "dispensify.claim.read"
};
// const GROUP_PERMISSION = {
//   [GROUPS.ADMIN]: PERMISSIONS.DISPENSIFY,
//   [GROUPS.DEV]: PERMISSIONS.DISPENSIFY,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_ICD10_READ,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_NDC_READ,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_USER_READ,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_USER_UPDATE,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_USERGROUP_READ,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_SITE,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_INVENTORY,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_INVENTORYSITE,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_PAD,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_PATIENT,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_PROVIDER,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_ORDER,
//   [GROUPS.MANAGER]: PERMISSIONS.DISPENSIFY_CLAIM,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_ICD10_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_NDC_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_USER_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_USER_UPDATE,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_USERGROUP_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_SITE_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_INVENTORY_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_INVENTORYSITE_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_PAD_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_PAD_PROMPT,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_PATIENT,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_PROVIDER_READ,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_ORDER,
//   [GROUPS.USER]: PERMISSIONS.DISPENSIFY_CLAIM,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_ICD10_READ,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_NDC_READ,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_USER,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_USERGROUP_READ,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_SITE_READ,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_SITE_UPDATE,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_INVENTORY_READ,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_INVENTORYSITE,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_PAD,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_PATIENT,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_PROVIDER,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_ORDER,
//   [GROUPS.SITE_ADMIN]: PERMISSIONS.DISPENSIFY_CLAIM,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_ICD10_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_NDC_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_USER_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_USER_UPDATE,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_USERGROUP_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_SITE_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_INVENTORY_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_INVENTORYSITE,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_PAD,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_PATIENT,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_PROVIDER_READ,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_ORDER,
//   [GROUPS.SITE_MANAGER]: PERMISSIONS.DISPENSIFY_CLAIM,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_ICD10_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_NDC_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_USER_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_USER_UPDATE,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_USERGROUP_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_SITE_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_INVENTORY_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_INVENTORYSITE_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_PAD_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_PAD_PROMPT,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_PATIENT,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_PROVIDER_READ,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_ORDER,
//   [GROUPS.SITE_USER]: PERMISSIONS.DISPENSIFY_CLAIM,
// };



//////////////////
// WEBPACK FOOTER
// ./src/shared/permissions.ts
// module id = 40
// module chunks = 0 1 2